define.alias("shared/components/shared/upgrade/feature", "calendar/components/shared/upgrade/feature");